import { combineReducers } from "@reduxjs/toolkit";

import { reducer as damagesReducer } from "../features/OC/Property/Damages/damages.slice";
import { reducer as incidentReducer } from "../features/OC/Property/Incident/incident.slice";
import { reducer as ownerReducer } from "../features/OC/Property/Owner/owner.slice";
import { reducer as perpetratorReducer } from "../features/OC/Property/Perpetrator/perpetrator.slice";
import { reducer as summaryReducer } from "../features/OC/Property/Summary/summary.slice";

export const ocPropertyFormReducer = combineReducers({
  perpetrator: perpetratorReducer,
  incident: incidentReducer,
  owner: ownerReducer,
  damages: damagesReducer,
  summary: summaryReducer,
});
